module.exports = __webpack_public_path__ + "static/treatspace-web-4492c91dab396ccc74071dfdffc907ae.jpg";